// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "clsx", "cva", "../Icon", "../Typography/Base", "./Base", "../../common/utils", "../Spinner", "./Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("clsx"), require("cva"), require("../Icon"), require("../Typography/Base"), require("./Base"), require("../../common/utils"), require("../Spinner"), require("./Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.clsx, global.cva, global.Icon, global.Base, global.Base, global.utils, global.Spinner, global.Icon);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _clsx, _cva, _Icon, _Base, _Base2, _utils, _Spinner, _Icon2) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    Button: true
  };
  _exports.Button = void 0;
  _react = _interopRequireDefault(_react);
  _clsx = _interopRequireDefault(_clsx);
  Object.keys(_Icon2).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in _exports && _exports[key] === _Icon2[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _Icon2[key];
      }
    });
  });
  var _excluded = ["className", "label", "loading", "prefixIcon", "size", "suffixIcon", "variant"];
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
  var iconClasses = 'cop-h-3 cop-w-3 cop-fill-current cop-stroke-current';
  var buttonVariants = (0, _cva.cva)({
    variants: {
      size: {
        sm: 'cop-py-[3px] cop-px-2',
        base: 'cop-px-3 cop-py-1'
      }
    },
    defaultVariants: {
      size: 'base'
    }
  });

  // functionally the same as Omit<BaseButtonProps, 'children' | 'variant'>
  // we're using this instead because Omit breaks in the build

  var Button = _exports.Button = function Button(_ref) {
    var className = _ref.className,
      label = _ref.label,
      loading = _ref.loading,
      prefixIcon = _ref.prefixIcon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'base' : _ref$size,
      suffixIcon = _ref.suffixIcon,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement(_Base2.BaseButton, _extends({
      "aria-label": loading ? 'Loading...' : props['aria-label'],
      className: (0, _utils.cn)(buttonVariants({
        size: size
      }), className),
      variant: variant === 'text' ? 'minimal' : variant
    }, props), loading ? /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, {
      size: 5
    }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, prefixIcon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: prefixIcon,
      className: (0, _clsx["default"])('cop-pr-2', iconClasses)
    }), /*#__PURE__*/_react["default"].createElement(_Base.Base, {
      size: size === 'base' ? 'base' : 'xs',
      leading: size === 'base' ? '1' : '075',
      tag: "p",
      weight: "medium",
      variant: "body"
    }, label), suffixIcon && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: suffixIcon,
      className: (0, _clsx["default"])('cop-pl-1.5', iconClasses)
    })));
  };
});
